/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DataVaxiomInsuranceBillingCenter/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Address from './Address/index'
import CancelAction from './CancelAction/index'
import Email from './Email/index'
import Name from './Name/index'
import PayerId from './PayerId/index'
import Phone from './Phone/index'
import React from 'react'
import SaveAction from './SaveAction/index'
import TysiaModalContent from 'DesignSystem/TysiaModal/TysiaModalContent/index'
import TysiaModalFooter from 'DesignSystem/TysiaModal/TysiaModalFooter/index'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function DataVaxiomInsuranceBillingCenter({
  children,
  viewPath = "/DesignSystem/DataVaxiomInsuranceBillingCenter"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<TysiaModalContent
  viewPath={`${viewPath}/TysiaModalContent`}
 paddingTop={0}
>
{childProps => (
<React.Fragment>
<Name
{...childProps}
  viewPath={`${viewPath}/Name`}
/>
<PayerId
{...childProps}
  viewPath={`${viewPath}/PayerId`}
/>
<Address
{...childProps}
  viewPath={`${viewPath}/Address`}
/>
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceM}
 text="Contact Information"
/>
<Phone
{...childProps}
  viewPath={`${viewPath}/Phone`}
/>
<Email
{...childProps}
  viewPath={`${viewPath}/Email`}
/>
</React.Fragment>
)}
</TysiaModalContent>
<TysiaModalFooter
  viewPath={`${viewPath}/TysiaModalFooter`}
>
{childProps => (
<React.Fragment>
<CancelAction
{...childProps}
  viewPath={`${viewPath}/CancelAction`}
/>
<SaveAction
{...childProps}
  viewPath={`${viewPath}/SaveAction`}
/>
</React.Fragment>
)}
</TysiaModalFooter>
{children}
</React.Fragment>)
}